import { createSelector } from 'reselect'
import { selectCustomerBuyersEnabled } from './customerProfile'
import { every } from './utils'
import { selectHasRequestedClient } from './client'

export const selectClientShouldSeeMarketsAndBuyerNavButtons = createSelector(
  selectHasRequestedClient,
  selectCustomerBuyersEnabled,
  every
)
